import { THEME_NAMES } from "./config";
import { assetPackIds } from "nemuru-components";

export const nemuruTheme = {
  zendeskCustomerSupport: true,
  themeName: THEME_NAMES.nemuru,
  palette: {
    primary: {
      main: "#4dd970",
      contrastText: "#08404d",
    },
    secondary: {
      main: "#08404d",
      contrastText: "#fff",
    },
    warning: {
      main: "#ffca28",
      contrastText: "#ffffff",
      light: "rgba(255, 202, 40, 0.15)",
    },
    info: {
      main: "#36a3f7",
      contrastText: "#ffffff",
      light: "#E1F1FD",
    },
    success: {
      main: "#4dd970",
      contrastText: "#ffffff",
      light: "rgba(73,217,106,0.15)",
    },
    error: {
      main: "#ef5957",
      contrastText: "#ffffff",
      light: "rgba(239,87,87,0.15)",
    },
    text: {
      title: "#08404d",
      primary: "#4b5354",
      secondary: "#77787b",
    },
    // additional colors
    dark: {
      main: "#08404d",
      accent: "#4dd970",
      contrastText: "#ffffff",
      imageBackgroundOpacity: 0.8,
    },
    status: {
      active: "#4dd970",
      approved: "#43b46f",
      analysing: "#36a3f7",
      sent: "#08404d",
      cancelled: "#d8d8d8",
      denied: "#ef5957",
    },
    grey: {
      50: "#fafafa",
      100: "#f5f5f2",
      200: "#eae9e6",
      300: "#dad9d6",
      400: "#b6b5b2",
      500: "#969593",
      600: "#6e6d6b",
      700: "#5a5a57",
      800: "#3c3b39",
      900: "#1b1b19",
    },
  },
  assetPackDefsId: assetPackIds.FILLED,
  background: null,
  customBorderRadius: {
    button: 25,
    paper: 15,
    chip: 6,
  },
};
